// Copyright (c) Zammo Inc.

import styled from 'styled-components';

import { palette } from '../../styles/variables';

type IsChatActiveType = {
  isChatActive: boolean;
};

export const VoiceSimulatorContainer = styled.div`
  position: relative;
  text-align: center;
  height: calc(100vh - 150px);
  padding-top: 2rem;
  overflow: hidden;
  padding-left: 1rem;
  padding-right: 1rem;

  @media screen and (min-width: 425px) {
    max-width: 425px;
    margin: auto;
    border: 15px solid #000;
    border-radius: 40px;
  }
`;

export const MicrophoneButtonContainer = styled.div<IsChatActiveType>`
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin-top: ${(props) => (props.isChatActive ? '2rem' : '3rem')};
`;

export type IsVisiblePropos = {
  isVisible?: boolean;
};

export const LastBotActivityContainer = styled.div<IsVisiblePropos>`
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
  position: relative;
`;

export const CustomDictationInterimsContainer = styled.div<IsVisiblePropos>`
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
  position: relative;
  color: grey;
`;

export const FlagImage = styled.img`
  height: 14px;
  margin-right: 6px;
`;

export const Wrapper = styled.div`
  z-index: 10;
  overflow: auto;
  transform: translateY(5%);
  max-width: 900px;
  height: calc(100% - 200px);
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 5px 40px rgba(0, 0, 0, 0.16);
  transition: transform 0.2s ease-in-out;
  transition-property: transform, opacity;
  border: solid 2px #1976d2;
  background: white;

  display: flex;
  flex-direction: column;

  opacity: 1;
  animation: zoomIn 0.2s cubic-bezier(0.42, 0, 0.58, 1);
  transform: translateY(0%);
`;

export const ChatBubble = styled.div`
  background: #ececec;
  border-color: #e6e6e6;
  border-radius: 4px 20px 20px;
  border-style: solid;
  border-width: 0;
  color: Black;
  min-height: 40px;
  max-width: 450px;
  padding: 15px;
  padding-bottom: 4px;
  border-radius: 15px;
  width: fit-content;
  max-width: 80%;
  word-break: break-word;
  word-wrap: break-word;
  text-align: left;
`;

export const ChatContainer = styled.div`
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
`;

export const ChatBubbleBot = styled(ChatBubble)`
  background: #ececec;
  border-color: #e6e6e6;
  color: Black;
  border-bottom-left-radius: 0;
  align-self: flex-start;
`;

export const ChatBubbleUser = styled(ChatBubble)`
  background: #1976d2;
  border-color: #e6e6e6;
  color: White;
  border-bottom-right-radius: 0;
  align-self: flex-end;
`;

export const ChatWrapper = styled.div`
  height: 100%;
  max-height: calc(100% - 180px);
  overflow-y: auto;
`;

export const ViewHistoryButton = styled.button`
  z-index: 11;
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 422px;
  display: inline-block;
  padding: 20px;
  background-color: #f6f9fa;
  border: none;
  font-size: 1.2em;
`;

type MicrophoneButtonProps = {
  dictating: boolean;
  isBotResponding: boolean;
};

export const MicrophoneButton = styled.button<MicrophoneButtonProps & IsChatActiveType>`
  height: ${(props) => (props.isChatActive ? '100px' : '300px')};
  width: ${(props) => (props.isChatActive ? '100px' : '300px')};
  border-radius: 50%;
  display: inline-block;
  padding: 0;
  background: ${(props) =>
    props.isBotResponding
      ? '#96b2f2 radial-gradient(circle, transparent 1%, #96b2f2 1%) center/15000%'
      : props.dictating
      ? palette.pink
      : palette.blue};

  background-position: center;
  transition: background 0.8s;
  ${(props) =>
    !props.isBotResponding &&
    `
    &:hover {
      background: 
        ${
          props.dictating
            ? `#ff007440 radial-gradient(circle, transparent 1%, #ff007440 1%) center/15000%`
            : `#96b2f2 radial-gradient(circle, transparent 1%, #96b2f2 1%) center/15000%`
        };
      }`}

  &:active {
    background-color: #008cff;
    background-size: 100%;
    transition: background 0s;
  }

  font-size: 72px;
  color: white;
  border: none;
`;

export const MicrophoneIconContainer = styled.div<IsChatActiveType>`
  font-size: ${(props) => (props.isChatActive ? '3rem' : '7rem')};
  height: ${(props) => (props.isChatActive ? '100%' : '150px')};
  display: flex;
  justify-content: center;
  align-items: ${(props) => (props.isChatActive ? 'center' : 'flex-end')};
`;

export const MicrophonTextContainer = styled.div`
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MicrophonText = styled.p`
  font-size: 1.5rem;
  margin: 0;
  padding: 0 2.5rem;
`;

export const Control = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
`;

export const RespondingLine = styled.div`
  height: 6px;
  width: 100%;
  position: absolute;
  top: calc(50% - 3px);
  background: ${palette.blue};
  z-index: -1;
`;

type CaptionContainerProps = {
  isBot?: boolean;
};
export const CaptionContainer = styled.div<CaptionContainerProps>`
  max-width: 900px;
  margin: 2rem auto 0;
  padding: 1rem;
  text-align: left;
  background: ${(props) => (props.isBot ? palette.mediumGray : palette.blue)};
  color: ${(props) => (props.isBot ? palette.black : palette.white)};
  border-radius: 15px;
  ${(props) =>
    props.isBot
      ? `
    border-bottom-left-radius: 0;
  `
      : `
    border-bottom-right-radius: 0;
  `}
`;

export const Caption = styled.div`
  font-size: 2rem;
  line-height: 1.4;
  text-align: left;
  margin: auto;

  > div:first-of-type {
    margin-bottom: 1rem;
  }
`;

export const InteractionLineWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 10px;
  width: calc(100% - 40px);
  margin: 0 20px;
  background: #05a0d1;
`;

export const BrightLine = styled.div<{ width: number }>`
  height: 100%;
  width: ${(props) => props.width}%;
  background: #46d3ff;
  transition: width 0.2s ease;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100px;
  height: 100px;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding-bottom: 20px;
`;
